const enTosHtml = `<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:m="http://schemas.microsoft.com/office/2004/12/omml" xmlns="http://www.w3.org/TR/REC-html40"><head>
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<meta name="ProgId" content="Word.Document">
<meta name="Generator" content="Microsoft Word 15">
<meta name="Originator" content="Microsoft Word 15">
<link rel="File-List" href="En-TOS%20V1%20Keilot%20(1)_files/filelist.xml">
<link rel="Edit-Time-Data" href="En-TOS%20V1%20Keilot%20(1)_files/editdata.mso">
<!--[if !mso]>
<style>
v\:* {behavior:url(#default#VML);}
o\:* {behavior:url(#default#VML);}
w\:* {behavior:url(#default#VML);}
.shape {behavior:url(#default#VML);}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:DocumentProperties>
  <o:Author>Ehsnullah Qadeer</o:Author>
  <o:LastAuthor>Ehsnullah Qadeer</o:LastAuthor>
  <o:Revision>2</o:Revision>
  <o:TotalTime>1</o:TotalTime>
  <o:Created>2025-11-19T09:45:00Z</o:Created>
  <o:LastSaved>2025-11-19T09:45:00Z</o:LastSaved>
  <o:Pages>1</o:Pages>
  <o:Words>6284</o:Words>
  <o:Characters>35820</o:Characters>
  <o:Lines>298</o:Lines>
  <o:Paragraphs>84</o:Paragraphs>
  <o:CharactersWithSpaces>42020</o:CharactersWithSpaces>
  <o:Version>16.00</o:Version>
 </o:DocumentProperties>
</xml><![endif]-->
<link rel="themeData" href="En-TOS%20V1%20Keilot%20(1)_files/themedata.thmx">
<link rel="colorSchemeMapping" href="En-TOS%20V1%20Keilot%20(1)_files/colorschememapping.xml">
<!--[if gte mso 9]><xml>
 <w:WordDocument>
  <w:EmbedTrueTypeFonts/>
  <w:SpellingState>Clean</w:SpellingState>
  <w:GrammarState>Clean</w:GrammarState>
  <w:TrackMoves>false</w:TrackMoves>
  <w:TrackFormatting/>
  <w:PunctuationKerning/>
  <w:ValidateAgainstSchemas/>
  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>
  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>
  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>
  <w:DoNotPromoteQF/>
  <w:LidThemeOther>en-PK</w:LidThemeOther>
  <w:LidThemeAsian>X-NONE</w:LidThemeAsian>
  <w:LidThemeComplexScript>AR-SA</w:LidThemeComplexScript>
  <w:Compatibility>
   <w:BreakWrappedTables/>
   <w:SnapToGridInCell/>
   <w:WrapTextWithPunct/>
   <w:UseAsianBreakRules/>
   <w:DontGrowAutofit/>
   <w:SplitPgBreakAndParaMark/>
   <w:EnableOpenTypeKerning/>
   <w:DontFlipMirrorIndents/>
   <w:OverrideTableStyleHps/>
  </w:Compatibility>
  <w:DoNotOptimizeForBrowser/>
  <m:mathPr>
   <m:mathFont m:val="Cambria Math"/>
   <m:brkBin m:val="before"/>
   <m:brkBinSub m:val="&#45;-"/>
   <m:smallFrac m:val="off"/>
   <m:dispDef/>
   <m:lMargin m:val="0"/>
   <m:rMargin m:val="0"/>
   <m:defJc m:val="centerGroup"/>
   <m:wrapIndent m:val="1440"/>
   <m:intLim m:val="subSup"/>
   <m:naryLim m:val="undOvr"/>
  </m:mathPr></w:WordDocument>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="false"
  DefSemiHidden="false" DefQFormat="false" DefPriority="99"
  LatentStyleCount="376">
  <w:LsdException Locked="false" Priority="0" QFormat="true" Name="Normal"/>
  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 1"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 2"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 3"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 4"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 5"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 6"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 7"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 8"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 9"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 1"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 2"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 3"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 4"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 5"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 6"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 7"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 8"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="header"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footer"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index heading"/>
  <w:LsdException Locked="false" Priority="35" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="caption"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of figures"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope return"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="line number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="page number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of authorities"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="macro"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="toa heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 5"/>
  <w:LsdException Locked="false" Priority="10" QFormat="true" Name="Title"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Closing"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Signature"/>
  <w:LsdException Locked="false" Priority="1" SemiHidden="true"
   UnhideWhenUsed="true" Name="Default Paragraph Font"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Message Header"/>
  <w:LsdException Locked="false" Priority="11" QFormat="true" Name="Subtitle"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Salutation"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Date"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Note Heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Block Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="FollowedHyperlink"/>
  <w:LsdException Locked="false" Priority="22" QFormat="true" Name="Strong"/>
  <w:LsdException Locked="false" Priority="20" QFormat="true" Name="Emphasis"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Document Map"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Plain Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="E-mail Signature"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Top of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Bottom of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal (Web)"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Acronym"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Cite"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Code"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Definition"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Keyboard"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Preformatted"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Sample"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Typewriter"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Variable"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Table"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation subject"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="No List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Contemporary"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Elegant"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Professional"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Balloon Text"/>
  <w:LsdException Locked="false" Priority="39" Name="Table Grid"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Theme"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Placeholder Text"/>
  <w:LsdException Locked="false" Priority="1" QFormat="true" Name="No Spacing"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 1"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 1"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Revision"/>
  <w:LsdException Locked="false" Priority="34" QFormat="true"
   Name="List Paragraph"/>
  <w:LsdException Locked="false" Priority="29" QFormat="true" Name="Quote"/>
  <w:LsdException Locked="false" Priority="30" QFormat="true"
   Name="Intense Quote"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 1"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 1"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 2"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 2"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 2"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 3"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 3"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 3"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 4"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 4"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 4"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 5"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 5"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 5"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 6"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 6"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 6"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="19" QFormat="true"
   Name="Subtle Emphasis"/>
  <w:LsdException Locked="false" Priority="21" QFormat="true"
   Name="Intense Emphasis"/>
  <w:LsdException Locked="false" Priority="31" QFormat="true"
   Name="Subtle Reference"/>
  <w:LsdException Locked="false" Priority="32" QFormat="true"
   Name="Intense Reference"/>
  <w:LsdException Locked="false" Priority="33" QFormat="true" Name="Book Title"/>
  <w:LsdException Locked="false" Priority="37" SemiHidden="true"
   UnhideWhenUsed="true" Name="Bibliography"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="TOC Heading"/>
  <w:LsdException Locked="false" Priority="41" Name="Plain Table 1"/>
  <w:LsdException Locked="false" Priority="42" Name="Plain Table 2"/>
  <w:LsdException Locked="false" Priority="43" Name="Plain Table 3"/>
  <w:LsdException Locked="false" Priority="44" Name="Plain Table 4"/>
  <w:LsdException Locked="false" Priority="45" Name="Plain Table 5"/>
  <w:LsdException Locked="false" Priority="40" Name="Grid Table Light"/>
  <w:LsdException Locked="false" Priority="46" Name="Grid Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="Grid Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="Grid Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="46" Name="List Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="List Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="List Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hashtag"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Unresolved Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Link"/>
 </w:LatentStyles>
</xml><![endif]-->
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;
	mso-font-charset:0;
	mso-generic-font-family:roman;
	mso-font-pitch:variable;
	mso-font-signature:-536869121 1107305727 33554432 0 415 0;
	mso-font-src:0;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-parent:"";
	margin:0cm;
	line-height:115%;
	mso-pagination:widow-orphan;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;
	mso-fareast-font-family:Arial;
	mso-ansi-language:EN;}
h1
	{mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:20.0pt;
	margin-right:0cm;
	margin-bottom:6.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:1;
	font-size:20.0pt;
	font-family:"Arial",sans-serif;
	mso-font-kerning:0pt;
	mso-ansi-language:EN;
	font-weight:normal;}
h2
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:18.0pt;
	margin-right:0cm;
	margin-bottom:6.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:2;
	font-size:16.0pt;
	font-family:"Arial",sans-serif;
	mso-ansi-language:EN;
	font-weight:normal;}
h3
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:16.0pt;
	margin-right:0cm;
	margin-bottom:4.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:3;
	font-size:14.0pt;
	font-family:"Arial",sans-serif;
	color:#434343;
	mso-ansi-language:EN;
	font-weight:normal;}
h4
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:14.0pt;
	margin-right:0cm;
	margin-bottom:4.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:4;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	color:#666666;
	mso-ansi-language:EN;
	font-weight:normal;}
h5
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:12.0pt;
	margin-right:0cm;
	margin-bottom:4.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:5;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;
	color:#666666;
	mso-ansi-language:EN;
	font-weight:normal;}
h6
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:12.0pt;
	margin-right:0cm;
	margin-bottom:4.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	mso-outline-level:6;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;
	color:#666666;
	mso-ansi-language:EN;
	font-weight:normal;
	font-style:italic;}
p.MsoCommentText, li.MsoCommentText, div.MsoCommentText
	{mso-style-noshow:yes;
	mso-style-priority:99;
	mso-style-link:"Comment Text Char";
	margin:0cm;
	mso-pagination:widow-orphan;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	mso-fareast-font-family:Arial;
	mso-ansi-language:EN;}
span.MsoCommentReference
	{mso-style-noshow:yes;
	mso-style-priority:99;
	mso-ansi-font-size:8.0pt;
	mso-bidi-font-size:8.0pt;}
p.MsoTitle, li.MsoTitle, div.MsoTitle
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:3.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	font-size:26.0pt;
	font-family:"Arial",sans-serif;
	mso-fareast-font-family:Arial;
	mso-ansi-language:EN;}
p.MsoSubtitle, li.MsoSubtitle, div.MsoSubtitle
	{mso-style-priority:11;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-next:Normal;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:16.0pt;
	margin-left:0cm;
	line-height:115%;
	mso-pagination:widow-orphan lines-together;
	page-break-after:avoid;
	font-size:15.0pt;
	font-family:"Arial",sans-serif;
	mso-fareast-font-family:Arial;
	color:#666666;
	mso-ansi-language:EN;}
span.CommentTextChar
	{mso-style-name:"Comment Text Char";
	mso-style-noshow:yes;
	mso-style-priority:99;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Comment Text";
	mso-ansi-font-size:10.0pt;
	mso-bidi-font-size:10.0pt;}
span.SpellE
	{mso-style-name:"";
	mso-spl-e:yes;}
.MsoChpDefault
	{mso-style-type:export-only;
	mso-default-props:yes;
	font-family:"Arial",sans-serif;
	mso-ascii-font-family:Arial;
	mso-fareast-font-family:Arial;
	mso-hansi-font-family:Arial;
	mso-bidi-font-family:Arial;
	mso-font-kerning:0pt;
	mso-ligatures:none;
	mso-ansi-language:EN;}
.MsoPapDefault
	{mso-style-type:export-only;
	line-height:115%;}
@page WordSection1
	{size:612.0pt 792.0pt;
	margin:72.0pt 72.0pt 72.0pt 72.0pt;
	mso-header-margin:36.0pt;
	mso-footer-margin:36.0pt;
	mso-page-numbers:1;
	mso-paper-source:0;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 @list l0
	{mso-list-id:340426279;
	mso-list-template-ids:-168243880;}
@list l0:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l0:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1
	{mso-list-id:670137170;
	mso-list-template-ids:-2063450412;}
@list l1:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l1:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2
	{mso-list-id:686181193;
	mso-list-template-ids:619577892;}
@list l2:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l2:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3
	{mso-list-id:1170873339;
	mso-list-template-ids:1312986968;}
@list l3:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l3:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4
	{mso-list-id:1401751029;
	mso-list-template-ids:1654660940;}
@list l4:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l4:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5
	{mso-list-id:1476752830;
	mso-list-template-ids:-1209098828;}
@list l5:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l5:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6
	{mso-list-id:1903562545;
	mso-list-template-ids:-95003014;}
@list l6:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l6:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7
	{mso-list-id:2083718451;
	mso-list-template-ids:1229116210;}
@list l7:level1
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level2
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level3
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level4
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level5
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level6
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level7
	{mso-level-number-format:bullet;
	mso-level-text:\\25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level8
	{mso-level-number-format:bullet;
	mso-level-text:\\25CB;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
@list l7:level9
	{mso-level-number-format:bullet;
	mso-level-text:\\25A0;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-18.0pt;
	text-decoration:none;
	text-underline:none;}
ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
-->
</style>
<!--[if gte mso 10]>
<style>
 /* Style Definitions */
 table.MsoNormalTable
	{mso-style-name:"Table Normal";
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-noshow:yes;
	mso-style-priority:99;
	mso-style-parent:"";
	mso-padding-alt:0cm 5.4pt 0cm 5.4pt;
	mso-para-margin:0cm;
	line-height:115%;
	mso-pagination:widow-orphan;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;
	mso-ansi-language:EN;}
table.TableNormal
	{mso-style-name:TableNormal;
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-unhide:no;
	mso-style-parent:"";
	mso-padding-alt:5.0pt 5.0pt 5.0pt 5.0pt;
	mso-para-margin:0cm;
	line-height:115%;
	mso-pagination:widow-orphan;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;
	mso-ansi-language:EN;}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:shapedefaults v:ext="edit" spidmax="1026"/>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <o:shapelayout v:ext="edit">
  <o:idmap v:ext="edit" data="1"/>
 </o:shapelayout></xml><![endif]-->
</head>

<body lang="en-PK" style="tab-interval:36.0pt;word-wrap:break-word">

<div class="WordSection1">

<h2 style="margin-top:0;margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_alkyc7f4rj8y"></a><span class="SpellE"><b><span lang="EN" style="font-size:17.0pt;line-height:115%">Keilot</span></b></span><b><span lang="EN" style="font-size:17.0pt;line-height:115%"> Terms of Use<o:p></o:p></span></b></h2>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Last updated: June 2025<o:p></o:p></span></b></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">The following terms (“<b>Terms of Use</b>”
or “<b>Terms</b>”) govern your access to and use of the <span class="SpellE">Keilot</span>
website and mobile application, including all content, functionality, and
services offered on or through [Keilot.com website address] or the <span class="SpellE">Keilot</span> mobile application (the “<b>Site</b>”), operated by
Keilot.com Ltd. (address: [Keilot.com Ltd. address in Israel]) and its
subsidiaries (if any), as applicable. Keilot.com Ltd. and its subsidiaries will
be referred to collectively as “<span class="SpellE"><b>Keilot</b></span><b>®</b>,”
“<b>we</b>,” or “<b>our</b>,” and “<b>you</b>” or “<b>user</b>” refer to you as
a user of the Site.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Please read these Terms of Use carefully
before you begin using the Site. By using the Site, opening an account, or
clicking the “I Agree” or “Accept” button when this option is available to you,
you accept and agree, on your own behalf or on behalf of your employer or any
other entity (if applicable), to be bound by and comply with these Terms of
Use, the <span class="SpellE">Keilot</span> Payment Terms, available [here] (“<b>Payment
Terms</b>”), the <span class="SpellE">Keilot</span> Community Standards,
available [here], and any additional in-product standards, terms, policies,
guidelines, and disclosures (together, the “<b>Terms</b>”), which are
incorporated herein by reference. You also acknowledge that you have read and
understood our Privacy Policy, available [here]. If you do not wish to agree to
these Terms or the Privacy Policy, you must not access or use the Site. For
further details regarding operations and use of the Site, please review the
relevant articles within these Terms.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Our customer support team is available
[hours of operation, e.g., 24/7] if you have any questions regarding the Site
or the Terms. You may contact our support team by submitting a request [here].
For more information about our designated contact points, see [here].</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h2 style="margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_ti46wyynii28"></a><b><span lang="EN" style="font-size:17.0pt;
line-height:115%">1. Representations and Warranties<o:p></o:p></span></b></h2>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">This Site is offered and available to
users who are at least 18 years old and of legal age to form a binding
contract. If you are under 18 but at least 13, you may use the Site only
through an account owned by a parent or legal guardian and with their proper
consent. If you are under 13, you may not use the Site or <span class="SpellE">Keilot</span>
services.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">The Site is available only to users who
are not subject to economic sanctions or trade restrictions imposed by the
United States, the European Union, or any other relevant jurisdiction.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">By using the Site, you represent and
warrant that you meet all of the above eligibility requirements. If you do not
meet these requirements, you must not access or use the Site.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h2 style="margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_d3phfo7sp6"></a><b><span lang="EN" style="font-size:17.0pt;
line-height:115%">2. Key Terms<o:p></o:p></span></b></h2>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Community/Communities:</span></b><span lang="EN"> A group of users who have organized around a shared interest, need, or
identity, within which <span class="SpellE">Keilot</span> activity occurs between
suppliers and consumers. The community selects the suppliers, and suppliers
select the communities in which they operate.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Consumers:</span></b><span lang="EN">
Users purchasing services on <span class="SpellE">Keilot</span>.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Suppliers:</span></b><span lang="EN">
Users offering and providing services on <span class="SpellE">Keilot</span>.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Custom Offers:</span></b><span lang="EN"> Exclusive offers a supplier can create in response to a consumer’s
specific requirements.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Service(s):</span></b><span lang="EN">
Services offered on <span class="SpellE">Keilot</span>, including through a
Custom Offer or an hours-based model.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Service Page:</span></b><span lang="EN">
A virtual page where the supplier may describe the service and its terms, and
the consumer may purchase the service and create an order.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Order(s):</span></b><span lang="EN"> The
formal agreements between a consumer and a supplier, including orders via
Service Page, Custom Offer, or hours model.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Order Page:</span></b><span lang="EN">
The place where consumers and suppliers communicate regarding the ordered
service.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Business Management System:</span></b><span lang="EN"> The platform’s functionality that allows suppliers to manage orders,
payments, hours, inventory, and communication with customers.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Community Exclusivity:</span></b><span lang="EN"> The level of exclusivity granted to a supplier within a specific
community, allowing for business planning and stability.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Community Termination:</span></b><span lang="EN"> A mechanism for dealing with suppliers who do not meet community
standards, allowing the community to discontinue their activity on the platform
in cases of poor service, instead of relying on public reviews.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h2 style="margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_tzab1t4mjqdv"></a><b><span lang="EN" style="font-size:17.0pt;
line-height:115%">3. Overview (Key Terms, in a nutshell)<o:p></o:p></span></b></h2>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Only registered users may buy and sell on
<span class="SpellE">Keilot</span>. When registering for an account, you agree to
provide us with accurate, complete, and up-to-date information about your
business or personal details and to update such information as needed without
unreasonable delay. You may not create an account for fraudulent or misleading
purposes. You are solely responsible for all activity under your account and
for maintaining the confidentiality and security of your password. We are not
responsible for any acts or omissions by you in connection with your account.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers set their pricing at their sole
discretion.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Consumers pay <span class="SpellE">Keilot</span>
upfront to create an order, as detailed in the Payment Terms.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers must fulfill their orders and
may not cancel orders regularly or without valid justification. Cancellations
affect supplier reputation and status.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers earn account levels based on
performance metrics. See “Levels” below.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Users may not offer or accept payments
outside the Site.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">When purchasing from <span class="SpellE">Keilot</span>,
consumers receive full rights to the delivered work unless otherwise stated by
the supplier on their service page or agreed upon otherwise between supplier
and consumer.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> is a platform for services offered by suppliers. Consumers acknowledge
that they engage with all suppliers as independent contractors and will not
control or supervise how the services are performed.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> reserves the right to use any delivered work that the consumer agreed
to publish as part of a review or made public otherwise, for marketing and
promotional purposes and/or for any other purpose relevant to the Site’s
operation.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">We care about your privacy. You can read
our Privacy Policy [here].</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h2 style="margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_epy1ycqmyqsi"></a><b><span lang="EN" style="font-size:17.0pt;
line-height:115%">4. Suppliers<o:p></o:p></span></b></h2>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_c7iu4laoop6l"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">4.1 Basics<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers create Service Pages on <span class="SpellE">Keilot</span> to allow consumers to purchase their services.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers may also offer Custom Offers.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">For information about receiving payments,
fees, and taxes, see the Payment Terms.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Supplier ratings are calculated based on
feedback provided by consumers. High ratings allow suppliers to achieve
advanced supplier levels. In certain cases, extremely low ratings may result in
suspension of the supplier’s account (see “Levels” below) and/or community
termination.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers must maintain a general
liability insurance policy with sufficient coverage to cover all risks related
to performing their services.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">If you represent that you are selling on <span class="SpellE">Keilot</span> for purposes related to your primary job or
profession, you will be considered a “Business Supplier,” and the following
additional terms apply:<br>
<span style="mso-spacerun:yes">&nbsp;</span>(<span class="SpellE">i</span>) When
creating a service, or upon our request, business suppliers will be required to
submit the following information and documents to <span class="SpellE">Keilot</span>:<br>
<span style="mso-spacerun:yes">&nbsp;</span>(a) name, address, phone number, and
email address;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(b) a copy of an ID document (e.g.,
identity card, passport) or other electronic identification as required;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(c) payment details;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(d) business registration number or
equivalent identification and the commercial register in which the business
supplier is listed (if relevant);<br>
<span style="mso-spacerun:yes">&nbsp;</span>(e) a self-declaration committing to
offer only products or services that comply with applicable EU regulations; and<br>
<span style="mso-spacerun:yes">&nbsp;</span>(f) upon request, any additional
documents proving the information provided.<br>
<span style="mso-spacerun:yes">&nbsp;</span>(ii) If a business supplier fails to
provide such information and documents within a reasonable time, <span class="SpellE">Keilot</span> may restrict or suspend the account.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_y81atw7bia08"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">4.2 Services<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers may publish a limited number of
active services based on their level status, as specified [here].</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services created on <span class="SpellE">Keilot</span>
are user-generated content.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services and/or users may be removed from
the Site due to violations of the Terms, which may include (but are not limited
to):</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:36.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Illegal or
fraudulent services.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Copyright
infringement, trademark violation, or violation of a third party’s terms of
service reported via our Intellectual Property Claims Policy [here].<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Sexually
explicit, pornographic, inappropriate/obscene services.<br style="mso-special-character:
line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Intentional
duplication of services.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Spam,
nonsensical, violent, or misleading services.<br style="mso-special-character:
line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Services that
mislead consumers or others.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Resale of
regulated goods.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Academic work
performed on behalf of consumers.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Poor-quality
services or deliveries.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;
margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo8"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Promotion of <span class="SpellE">Keilot</span> or <span class="SpellE">Keilot</span> services through
activities prohibited by law or third-party terms, or any marketing activity
harming our relationship with users or partners.<br style="mso-special-character:
line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services removed for such violations may
result in supplier account suspension and/or community termination.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services permanently removed for
violations are not eligible for restoration or editing.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services may also be removed due to poor
performance or inappropriate user behavior.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services may include URLs to approved
website formats in the service description and requirement fields. Services
containing websites promoting content that violates <span class="SpellE">Keilot</span>
Terms will be removed.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services must include an appropriate
service image related to the offered service. Suppliers must provide the same
service quality as represented in the service images. Repeated mismatches may
result in loss of supplier level or permanent deactivation.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Statements in the service page that
contradict or bypass these Terms are prohibited.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_tch6yp7u0kse"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">4.3 Levels<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Our level system empowers suppliers
through metrics demonstrating their progress. As suppliers gain more experience
and advance to higher levels, they gain new benefits and tools.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Suppliers on <span class="SpellE">Keilot</span>
can earn account levels based on their activity and performance metrics. For
details on level criteria and performance metrics, see [here].</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> may update level criteria and benefits and tools for each level from
time to time.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Violations of these Terms may result in
freezing your account’s eligibility for level promotion, removing your account
from the level system, and/or affecting your eligibility for certain benefits
and tools.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_v8krnhqua9iz"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">4.4 Supplier Features<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> suppliers have access to several exclusive features that help
personalize the way they offer their services.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Custom Offer:<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Suppliers may
send Custom Offers tailored to a consumer’s specific requirements. Custom
Offers include an accurate description of the service, price, and estimated
delivery time. Custom Offers are sent from the conversation page. Services
delivered through Custom Offers may not violate <span class="SpellE">Keilot</span>
Terms.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Project Milestones:<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Services and
Custom Offers above [minimum amount, e.g., $100] may include up to [number of
milestones, e.g., six] project milestones. The minimum amount for each
milestone is [minimum amount, e.g., $50], and the project must include at least
two milestones. Each milestone is paid for and delivered separately based on
the description and schedule. After a milestone is delivered and marked as
delivered, consumers may choose to proceed with the next milestone or stop the
order. If the consumer does not pay for the next milestone within 10 days of
receiving previous milestones, work on subsequent milestones will not begin. A
milestone is automatically marked as completed if no acceptance or revision
request is submitted within 8 days of being marked “delivered,” but in such
case, all next milestones will not begin.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Service Subscription:<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Eligible
suppliers may offer consumers a fixed-term subscription for a specific service
(“Service Subscription”). During the subscription period, the supplier will
deliver one order of that service on a recurring basis, as agreed. Consumers
may cancel future subscription orders before payment is processed. After
payment, the <span class="SpellE">Keilot</span> cancellation policy applies per
the Payment Terms. Suppliers may cancel a subscription up to 10 days before the
next recurring order; otherwise, the cancellation policy applies.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_qsu23ay1wv2u"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">4.5 Delivery of Physical Goods<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Some <span class="SpellE">Keilot</span>
services are delivered physically (arts &amp; crafts, collectibles, etc.). For
these services:</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:36.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Services with
shipping prices must include physical items shipped to consumers.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Shipping
charges apply only to the supplier’s cost of shipping the physical items.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Consumers
purchasing services requiring physical delivery must provide a shipping
address.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Suppliers are
responsible for all shipping arrangements once the consumer provides the
address.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-left:36.0pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> does not handle or guarantee
shipping, tracking, item quality, condition, or delivery, and is not liable for
damages or issues arising from shipping.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<p class="MsoNormal" style="margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;
margin-left:36.0pt;text-indent:-18.0pt;mso-list:l6 level1 lfo2"><!--[if !supportLists]--><span lang="EN"><span style="mso-list:Ignore">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><!--[endif]--><span dir="LTR"></span><span lang="EN">Tracking
numbers are recommended to avoid disputes. Suppliers must provide a tracking
number on the order page if available.<br style="mso-special-character:line-break">
<!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
<!--[endif]--></span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<h2 style="margin-bottom:4.0pt;mso-pagination:widow-orphan;page-break-after:
auto"><a name="_vbrsozgnff3o"></a><b><span lang="EN" style="font-size:17.0pt;
line-height:115%">5. Consumers<o:p></o:p></span></b></h2>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_3toq6t5j039"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">5.1 Basics<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">You may not offer direct payments to
suppliers using payment methods outside the <span class="SpellE">Keilot</span>
platform.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span class="SpellE"><span lang="EN">Keilot</span></span><span lang="EN"> reserves the right to use any delivered work that the consumer agrees
to publish as part of a review or made public otherwise, for marketing and
promotional purposes and/or for any other purpose relevant to the operation of
the Site.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Services and content created by a
supplier at a consumer’s request must comply with the <span class="SpellE">Keilot</span>
Community Standards.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Consumers are solely responsible for
reviewing any potential delivery and other content and summaries created by
suppliers, ensuring they meet their needs and comply with the Community
Standards.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">When making a purchase on <span class="SpellE">Keilot</span>, you may use only funds obtained from lawful sources
and not connected—directly or indirectly—to unlawful or fraudulent activity.</span></p>

<h3 style="margin-top:14.0pt;mso-pagination:widow-orphan;page-break-after:auto"><a name="_3gbk1pkv601u"></a><b><span lang="EN" style="font-size:13.0pt;line-height:
115%;color:black">5.2 Purchasing<o:p></o:p></span></b></h3>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Please review the Payment Terms for
making payments through the Site and learning about fees and taxes.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">You may not offer or request to pay
suppliers using any method other than through the Keilot.com Site. If you are
asked to use an alternative payment method, report this immediately to customer
support [here].</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN">Here is the English translation, exactly
matching the original text with no additions or changes:</span></p>

<div class="MsoNormal" align="center" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">6. Orders<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><b>6.1 Basics<br>
</b><span style="mso-spacerun:yes">&nbsp;</span>After payment is approved, your
order will be created.<br>
<span style="mso-spacerun:yes">&nbsp;</span>An order is marked as “Completed” after
it is marked as “Delivered” and then accepted by a consumer. An order will be
automatically marked as “Completed” if it is not accepted and no request for
modification is submitted within 3 days after the order is marked as
“Delivered.” The consumer may extend this period by up to an additional 5 days.<br>
<span style="mso-spacerun:yes">&nbsp;</span>A milestone (in an order with
milestones) is marked as “Completed” after it is delivered by the provider and
then accepted by the consumer. A milestone will be automatically marked as
“Completed” if no acceptance or request for modification is submitted within 8
days after it is marked as “Delivered,” however, in such a case the order will be
paused and any upcoming milestones will not begin. After a milestone is
delivered and accepted, consumers may choose to continue with the order and pay
for the next milestone, or pause the order. If the consumer does not pay for
the next milestone within 10 days from the date of acceptance of previous
milestones, the order under the upcoming milestones will not begin. Please note
that if you choose to pause future milestones, the current milestone that was
ordered will not be canceled.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Consumers may purchase a service
subscription, if available on the provider’s service page. During the service
subscription period, a new order for that service will be created automatically
on a recurring basis, as agreed between provider and consumer. By purchasing a
service subscription, you authorize us to automatically charge you for each
order under the service subscription from your <span class="SpellE">Keilot</span>
balance or a saved payment method, as applicable. If you do not have a <span class="SpellE">Keilot</span> balance or a saved payment method, you will be asked
to approve the payment before the next order. In the event that a payment is
not processed or completed by the consumer, for any reason, orders under the
service subscription will be canceled. The consumer may also cancel future
orders under the service subscription before payment for such future orders is
made. After payment is made, <span class="SpellE">Keilot’s</span> order
cancellation policy applies according to the payment terms. Please note that
providers may cancel future orders under the service subscription 10 days
before the next recurring order.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Certain services offering local services
may require consumers and providers to meet in person in order for the provider
to perform the service. In such cases, users should note that <span class="SpellE">Keilot</span> does not guarantee the conduct, behavior, safety,
suitability, or ability of consumers or providers. Both consumers and providers
agree that full risk arising from their meeting and/or their use or performance
of local services remains solely with them, and <span class="SpellE">Keilot</span>
bears no responsibility or liability related to any local services provided by
providers. In the event that the service is performed at the consumer’s
premises, consumers are encouraged to maintain suitable insurance policies to
cover their liability as property owners. Keilot’s terms remain applicable to
orders conducted off-platform (including, without limitation, the below
restrictions on illegal use, inappropriate conduct and language, and targeted
abuse).</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">6.2 Order Handling<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>When a consumer
places an order, the provider receives an email notification as well as on-site
alerts upon logging into their account.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Providers are required to meet the
delivery time stated when creating their services or custom offers. Failure to
do so allows the consumer to cancel the order when an order is marked as late
and may affect the provider’s rating.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Providers must send completed files
and/or proof of work when marking the order as “Delivered.”<br>
<span style="mso-spacerun:yes">&nbsp;</span>The “Deliver Work” button may not be
misused by providers to bypass the order guidelines described in these terms.
Using the “Deliver Work” button when an order has not been fulfilled may result
in cancellation of the order after review, impact the provider’s rating, and
lead to a warning for the provider.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Users are responsible for scanning all
transferred files for viruses and malware. <span class="SpellE">Keilot</span>
will not be held responsible for any damage that may occur due to using the
website, using transferred content or files.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Consumers may use the “Request
Revisions” feature found on the order page when an order is marked as
“Delivered” if the delivered materials do not match the provider’s description
on their service page or do not meet the requirements sent to the provider at
the beginning of the order process.<br>
<span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span>
reserves the right to mark orders as “Completed” after a revision request in
cases where consumers have been unresponsive to their providers or if we
identify misuse of <span class="SpellE">Keilot’s</span> order system.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">6.3 Feedback and Community Dismissals<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Feedback
provided by consumers is an essential part of <span class="SpellE">Keilot’s</span>
rating system. For more information on <span class="SpellE">Keilot’s</span>
feedback system, see [here].<br>
<span style="mso-spacerun:yes">&nbsp;</span>Feedback will not be removed unless
there are clear violations of our terms.<br>
<span style="mso-spacerun:yes">&nbsp;</span>To prevent misuse of our feedback
system, all feedback must originate from legitimate and valid orders, as
detailed [here]. Purchases that are arranged, determined to artificially
enhance a provider’s ratings, or intended to abuse the website may result in
permanent suspension of all related accounts.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Delaying the delivery of required
services, files, or information needed to complete the provider’s service with
the intent of obtaining positive feedback or additional services is prohibited.
Providers may not request removal of feedback from their consumers through
mutual cancellations.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Once both the provider and the consumer
have completed their feedback, or once the relevant feedback period has passed,
all posted feedback becomes public.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Work samples are added to the provider’s
assets on <span class="SpellE">Keilot</span> if the consumer chooses to publish
the delivery when leaving public feedback.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>Community Dismissal Mechanism:</b> In
cases of unresolved or recurring poor service, <span class="SpellE">Keilot</span>
will allow the community to discuss and implement a “community dismissal”
mechanism that will result in the termination of the provider’s activity in
that community or on the platform as a whole, in accordance with community
rules and <span class="SpellE">Keilot</span> policy. This mechanism is intended
to ensure the quality of services provided in the community and maintain user
trust, without relying solely on public reviews.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">7. User-Generated Content (UGC)<o:p></o:p></span></b></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><b>7.1 Content
Responsibility and Compliance.</b> Providers must ensure that all content and
materials used to offer their services are their original work, do not infringe
third-party rights, and comply with all <span class="SpellE">Keilot</span> terms,
including as detailed in Section 10 below (“User-Generated Content”) and <span class="SpellE">Keilot’s</span> community guidelines. Providers are solely
responsible for all content and materials used to offer their services, as well
as any output or service provided on the basis of their content.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.2 Ownership of Input.</b> To the
extent permitted under applicable law, and provided providers hold the required
rights, providers retain their rights in the content used to create the
services.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.3 Ownership of Delivery.</b> To the
extent permitted under applicable law and subject to full payment, consumers
own the delivery (the completed work).<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.4 Similarity of Content and
Non-Exclusivity.</b> Providers and <span class="SpellE">Keilot</span> do not
guarantee that certain services provided will be unique or exclusive,
particularly if the services are similar or use common methods.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.5 Provider Use of Delivery.</b> If
consumers allow providers to publicly display the delivery (as part of a
portfolio or review), providers may use it to showcase their abilities within
the <span class="SpellE">Keilot</span> platform.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.6 Consumer Use of Delivery.</b>
Consumers are responsible for ensuring that their use of the delivery does not
infringe any third-party rights and complies with these terms and applicable
law, including intellectual property rights such as copyright or trademarks.<br>
<span style="mso-spacerun:yes">&nbsp;</span><b>7.7 Content Generation Limitations.</b>
<span class="SpellE">Keilot</span> does not guarantee the accuracy, reliability,
uniqueness, or suitability for specific purposes of services or any other
generated content. You must not rely on these services or generated content as
your sole source of truth. You must evaluate it for accuracy and applicability
to your use case, including using human review as needed.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">8. Conduct and User Protection</span><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span> enables people around the world to create, share,
sell, and purchase nearly any service they need at virtually unmatched value.<br>
<span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span>
maintains a friendly, community-oriented, and professional environment. Users
should preserve this spirit while participating in any activity or extensions
of <span class="SpellE">Keilot</span>. This section refers to the conduct
expected from users when interacting with one another on <span class="SpellE">Keilot</span>.<br>
<span style="mso-spacerun:yes">&nbsp;</span>To report violations of our terms,
inappropriate user behavior, or inquiries related to your account, please
contact our customer support team [here].</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.1 Basics<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>It is
prohibited to request or provide email addresses, third-party messaging apps,
phone numbers, or any other personal contact details for the purpose of
communicating outside <span class="SpellE">Keilot</span> to bypass or misuse
Keilot’s messaging system or platform.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Any necessary exchange of personal
information required to continue the service may be done within the order page.<br>
<span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span>
provides no guarantee as to the level of service offered by providers to
consumers. You may use the dispute resolution tools available on the order
page.<br>
<span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span> does
not provide protection for users engaging outside the website.<br>
<span style="mso-spacerun:yes">&nbsp;</span>All exchanges of information and files
must take place on the website only.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Offensive, abusive, or inappropriate
language, and violent or threatening messages will not be tolerated and may
result in an account warning or the suspension/removal of your account.<br>
<span style="mso-spacerun:yes">&nbsp;</span>You agree not to discriminate against
any other user based on gender, race, age, religious affiliation, sexual
orientation, or otherwise, and you acknowledge that such discrimination may
result in suspension/removal of your account.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Users may not submit offers or solicit
parties introduced through <span class="SpellE">Keilot</span> to contract, engage
with, or pay outside <span class="SpellE">Keilot</span>.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.2 Orders<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Users who
intend to defame competing providers by ordering from competing services will
have such reviews removed or face additional actions related to account status
as determined by our Trust &amp; Safety team.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Users should avoid sending spam or
solicitation to past consumers or providers in pursuit of removing/changing
reviews or canceling orders that do not comply with order cancellation or
feedback policies.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.3 Service Pages and Providers<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Providers</span> represent that all content included in their
services, on the service page, and on the provider page, is original work
created by the provider and does not infringe any third-party rights,
including, without limitation, copyrights, trademarks, or service marks. If
music or media clips from libraries are added to the service, service page, or
provider page, providers represent and warrant they hold a valid license to use
such music and/or clips and include them in the services.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Users may report services that may
violate <span class="SpellE">Keilot’s</span> terms based on substantial
similarity of the reported service to existing services (copied services) using
our reporting system or by contacting customer support.<br>
<span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span> will
respond to clear and complete notices of alleged copyright or trademark
infringement. To learn how to report intellectual property violations, click
[here]. If you are reporting copyright or trademark infringement, review our
designated Intellectual Property Claims Policy [here].</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.4 Reporting Violations<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>If you
encounter any content that may violate our terms and/or community guidelines,
you must report it to us through the appropriate channels established to
address such issues, as described in our terms. All cases are reviewed by our
Trust &amp; Safety team. Our decision may rely, among other things, on the
information you provided to us. To protect individual privacy, investigation
results are not shared. You may review our Privacy Policy for more information.
Any misuse of our reporting system, as detailed [here], may result in
restriction or permanent suspension of related accounts.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.5 Violations<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Users may
receive an account warning for violating our terms or any reported
inappropriate user behavior received by our Trust &amp; Safety team. A warning
will be sent to the user’s email address and displayed for such user on the
website. Warnings do not restrict account activity but may result in freezing
your account from level progression, removing your account from participation
in the level system, affecting your eligibility to sell on the platform or
certain benefits and tools, removing your services from our listings, or
permanently disabling your account.<br>
<span style="mso-spacerun:yes">&nbsp;</span>If we have taken action against a user
account or service(s) for violating our terms, we will send the user an email
explaining the reasons and basis for such actions, as well as their options
regarding further review. For more information, see our Notices and Appeals
section.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Prohibited Use<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Adult Services
and Pornography – <span class="SpellE">Keilot</span> does not allow any exchange
of sexually explicit or pornographic materials and services.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Inappropriate Behavior and Language –
Communication on <span class="SpellE">Keilot</span> must be friendly,
constructive, and professional. <span class="SpellE">Keilot</span> condemns
bullying, harassment, and hate speech toward others. We provide users with a
means to exchange messages privately between individuals, an order rating
system, and participation in larger platforms such as our community forum and
social media pages.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Phishing and Spam – Member safety is a
top priority. Any attempt to post or send malicious content intended to
compromise another member’s account or computing environment is strictly
prohibited. Please respect the privacy of our members by not contacting them
with offers, questions, proposals, or anything unrelated to their services or
orders.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Privacy and Identity – You may not
publish or post other people’s private and confidential information. Any
exchange of personal information required to complete a service must be
provided on the order page. Providers further confirm that any information they
receive from the consumer, which is not publicly available, will not be used
for any purpose other than delivering the work to the consumer. Any user
interacting and communicating outside <span class="SpellE">Keilot</span> will not
be protected by our terms of service.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Authentic <span class="SpellE">Keilot</span>
Profile – You may not create a false identity on <span class="SpellE">Keilot</span>,
misrepresent your identity, create a <span class="SpellE">Keilot</span> profile
for anyone other than yourself (a real person), or use or attempt to use
another user’s account or information; your profile details, including the
description, skills, location, etc., must be accurate and complete and may not
be misleading, illegal, offensive, or otherwise harmful. <span class="SpellE">Keilot</span>
reserves the right to require users to undergo an authentication process in
order to use the site (via ID, phone, camera, registry extract, documents,
etc.).<br>
<span style="mso-spacerun:yes">&nbsp;</span>Intellectual Property Claims – <span class="SpellE">Keilot</span> will respond to clear and complete notices of
alleged copyright or trademark infringement and/or violations of third-party
terms of service. Our Intellectual Property Claims Procedures may be reviewed
[here].<br>
<span style="mso-spacerun:yes">&nbsp;</span>Fraud / Illegal Use – You may not use <span class="SpellE">Keilot</span> for any illegal purposes or to conduct illegal
activities, including circumventing economic sanctions or trade restrictions
imposed by the United States, the European Union, or any other relevant
jurisdiction.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">Abuse and Spam<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Multiple
Accounts – To prevent fraud and abuse, users are limited to one active <span class="SpellE">Keilot</span> account. Any additional account determined to be
created to bypass guidelines, gain a competitive advantage, or mislead the <span class="SpellE">Keilot</span> community will be disabled. Creating multiple
accounts in bulk may result in disabling all related accounts. Note: Any
violation of <span class="SpellE">Keilot’s</span> terms may constitute grounds
for permanent suspension of all accounts.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Targeted Abuse – We do not tolerate
users engaging in targeted abuse or harassment toward other users on <span class="SpellE">Keilot</span>. This includes creating multiple new accounts to
harass users through our messaging or order system.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Account Selling – You may not buy or
sell <span class="SpellE">Keilot</span> accounts.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.6 Disputes and Cancellations<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>We encourage
our consumers and providers to try resolving conflicts between themselves. If
for any reason this fails after using the Resolution Center or if you encounter
prohibited use of the website, users may contact Keilot’s customer support
department for assistance [here]. For more information on disputes, order
cancellations, and refunds, see the payment terms.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.7 Content Moderation, Notices, and
Appeals<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><span class="SpellE">Keilot</span> is not generally obligated to proactively review
user-posted content for legality or compliance with the terms. However, we may
conduct voluntary checks on our initiative to identify and determine illegal or
non-compliant content and take appropriate action. We may take appropriate
action if we find, or receive notice of, a violation of the terms. For more
information about our content moderation processes, see [here].<br>
<span style="mso-spacerun:yes">&nbsp;</span>If <span class="SpellE">Keilot</span>
takes action against you, your account, or your content, you may file a
complaint against this decision. You may also file a complaint if you disagree
with our decision following a notice you submitted. In both cases, the deadline
for filing a complaint is six months from the date of receiving the relevant
notice. You may file a complaint by contacting our customer support. Please
explain in your complaint why you believe we should reverse our decision.<br>
<span style="mso-spacerun:yes">&nbsp;</span>We will handle complaints promptly,
non-discriminatorily, diligently, and objectively, and will reverse our
decision if we conclude it was made in error.<br>
<span style="mso-spacerun:yes">&nbsp;</span>If your residence or location is in the
European Economic Area (EEA), you may choose an out-of-court dispute settlement
body approved under Article 21(3) of the EU Digital Services Act (“Dispute
Settlement Body”) to resolve disputes related to our decisions regarding
content you uploaded or notices you submitted, including complaints not
resolved by our internal complaint-handling system.<br>
<span style="mso-spacerun:yes">&nbsp;</span>We reserve the right to refuse to
cooperate with the chosen Dispute Settlement Body if: (<span class="SpellE">i</span>)
the relevant dispute has already been resolved or is already subject to ongoing
proceedings before a competent court or another approved Dispute Settlement
Body; or (ii) the six-month period from our notice of the decision to you has
passed without you submitting a complaint through our internal
complaint-handling system or contacting the Dispute Settlement Body.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Decisions by Dispute Settlement Bodies
are not binding on any party.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.8 Proprietary Restrictions<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>The website,
including its features, overall layout, look and feel, design, information,
content, and other materials available on it (excluding UGC), and all related
intellectual property rights, are the exclusive property of <span class="SpellE">Keilot</span>.
<span class="SpellE">Keilot</span>® and all other registered trademarks are the
exclusive property of <span class="SpellE">Keilot</span>. Users have no right,
and expressly agree not to do the following in relation to the website or any
part, component, or extension of the website (including its mobile apps and any
third-party component or technology used to operate the website or any of its
features):<br>
<span style="mso-spacerun:yes">&nbsp;</span>(<span class="SpellE">i</span>) copy,
transmit, adapt, modify, distribute, transmit, display, create derivative
works, publish, or reproduce it in any way;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(ii) access it or use any delivery in
order to develop or build similar or competing products or features, seek to
obtain any ownership or license interest, sell, transfer, lease time, or rent
it (or attempt any of the foregoing);<br>
<span style="mso-spacerun:yes">&nbsp;</span>(iii) reverse engineer, disassemble,
decompile, or otherwise attempt to derive its source code, underlying ideas,
algorithms, structure, or organization;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(iv) remove any copyright notice,
identification, or other proprietary notices;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(v) use automation software (bots),
hacks, modifications (mods), or any other unauthorized third-party software
intended to modify the website;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(vi) attempt to gain unauthorized access
to, interfere with, damage, or disrupt the website or computer systems or
networks connected to the website;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(vii) circumvent, remove, alter,
disable, degrade, or thwart any technological measures or content protections
of the website;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(viii) use any robot, spider, scraper,
or other automated device, process, software, or queries that intercept,
“mine,” scrape, or access the website to monitor, retrieve, extract, copy, or
collect content or data from or through the website, or engage in any manual
process to do the same;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(ix) systematically retrieve data or
other content to create or compile, directly or indirectly, a collection,
compilation, database, or directory;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(x) inject viruses, Trojan horses,
worms, logic bombs, or other materials that are malicious or technologically
harmful into our systems;<br>
<span style="mso-spacerun:yes">&nbsp;</span>(xi) use the website in any manner that
could damage, disable, overburden, or impair the website, or interfere with
other users’ enjoyment of the website; or<br>
<span style="mso-spacerun:yes">&nbsp;</span>(xii) access or use the website in any
manner not expressly permitted by the terms. Users also agree not to permit or
authorize anyone else to do any of the above.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Except for the limited right to use the
website according to these Terms of Use, <span class="SpellE">Keilot</span> owns
all rights, title, and interest in the website (including all its intellectual
property rights), and you agree not to take any action inconsistent with these
ownership interests. We reserve all rights in relation to the website and its
content (excluding UGC), including without limitation the exclusive right to
create derivative works.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.9 Feedback Rights<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>To the extent
you provide <span class="SpellE">Keilot</span> with comments, suggestions, or any
other feedback regarding the website or other <span class="SpellE">Keilot</span>
products or services (“Feedback”), you are deemed to have granted <span class="SpellE">Keilot</span> exclusive, royalty-free, fully paid, perpetual,
irrevocable, worldwide rights in the Feedback. <span class="SpellE">Keilot</span>
is not obligated to implement any feedback received from users.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">8.10 Confidentiality<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Providers
should acknowledge that consumers may need to disclose certain confidential
information for providers to use in delivering the services, and to protect
this confidential information from unauthorized use and disclosure. Therefore,
providers agree to treat all information received from consumers as highly
sensitive, strictly confidential, and classified. Without limiting the above,
providers expressly agree: (<span class="SpellE">i</span>) to maintain complete
confidentiality of all such information; (ii) not to disclose the information
to any third parties; (iii) not to use the information for any purpose other
than delivering the services; and (iv) not to copy or reproduce any part of the
information without the consumer’s permission.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">9. Ownership</span><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span><b>9.1
Ownership and Limitations:</b> When purchasing a service on <span class="SpellE">Keilot</span>,
unless explicitly stated otherwise on the service page/provider description or
in the custom offer, when the work is delivered, and subject to payment, the
consumer receives all intellectual property rights, including but not limited
to copyrights in the delivered work, and the provider waives all moral rights
(to the extent permitted by applicable law). Accordingly, the provider
expressly assigns the copyrights in the delivered work to the consumer. Any
transfer and assignment of intellectual property to the consumer is subject to
full payment, and the delivery may not be used if payment is canceled for any
reason. For clarity, in custom-created work (such as artwork, design work,
report creation, etc.), the delivered work and its copyrights will be the
exclusive property of the consumer, and upon delivery, the provider agrees that
it hereby assigns, according to the terms, all rights, title, and interest in
the delivered work to the consumer. Some services (including custom-created
work) charge additional fees (via service add-ons) for a commercial use
license. This means that if you purchased the service for personal use, you
will own all necessary rights for such use and will not need the commercial use
license. If you intend to use it for any compensation or other payment, or for
any purpose directly or indirectly relating to a business or other
profit-oriented venture, you must purchase the commercial use license via a service
add-on and will hold broader rights covering your business use.<br>
<span style="mso-spacerun:yes">&nbsp;</span>Furthermore, users (both consumers and
providers) agree that unless explicitly stated otherwise, content voluntarily
created/uploaded by users to <span class="SpellE">Keilot</span>—including service
texts, images, videos, usernames, profile pictures, <span class="SpellE">Keilot</span>
replies, user videos, and any other information, including display of delivered
work—may be used by <span class="SpellE">Keilot</span> free of charge for
marketing purposes and/or any other purpose relevant to the operation and
functioning of the site.</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN">9.2 Commercial Use License<br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>By purchasing a
"Commercial Use License" with your order, the provider grants you a
perpetual, exclusive, non-transferable, worldwide license to use the purchased
delivery for permitted commercial purposes. For clarity, the provider retains
all ownership rights. “Permitted commercial purposes” means any
business-related use, such as (for example) advertising, promotion, creating
web pages, incorporating into a product, software, or other business tools, etc.,
and does not include any unlawful, immoral, or defamatory purpose. This license
is subject to <span class="SpellE">Keilot’s</span> terms. No warranties, express
or implied, come with this delivery, including regarding fitness for a
particular purpose. Neither the provider nor <span class="SpellE">Keilot</span>
will be liable for any claims or damages, incidental, consequential, or
otherwise, arising from this license, the delivery, or your use of the
delivery.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">10. Disclaimer of Warranties</span><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Your use of the
website, its content, its features, services, and programs, and any services or
items obtained through the website, is at your sole risk. The website, its
content, features, services, and programs, and any services or items obtained
through the website, are provided on an “as is” and “as available” basis,
without any warranty of any kind, whether express or implied, provided we have
acted with reasonable professional diligence. Neither <span class="SpellE">Keilot</span>
nor any entity associated with <span class="SpellE">Keilot</span> makes any
warranty or representation regarding the completeness, security, reliability,
quality, accuracy, or availability of the website.<br>
<span style="mso-spacerun:yes">&nbsp;</span>The foregoing does not affect any
warranty that cannot be excluded or limited under applicable law.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">11. Machine Translation</span><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Certain
user-generated content on the website has been translated for your convenience
using translation software powered by [Google / other translation service, if
applicable]. Reasonable efforts have been made to provide an accurate
translation, however no automatic translation is perfect and it is not intended
to replace human translators. Such translations are provided as a service to
the website’s users and are supplied “as is.” No warranty of any kind is given,
whether express or implied, regarding the accuracy, reliability, or correctness
of such translations made from English into any other language. Certain
user-generated content (such as images, videos, flash, etc.) may not be
translated accurately or at all due to limitations of the translation software.<br>
<span style="mso-spacerun:yes">&nbsp;</span>[Google / other translation service, if
applicable] disclaims all responsibility related to translations, express or
implied, including any warranties regarding accuracy, reliability, and any
implied warranties of merchantability, fitness for a particular purpose, and
non-infringement.<br>
<span style="mso-spacerun:yes">&nbsp;</span>The official text is the English version
of the website. Any discrepancies or differences that arise in the translation
are not binding and have no legal effect for compliance or enforcement
purposes. If any questions arise regarding the accuracy of the information
contained in the translated content, please refer to the English version of the
content, which is the official version.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><b><span lang="EN" style="font-size:17.0pt;line-height:
115%">12. Limitation of Liability</span><span lang="EN"><br>
</span></b><span lang="EN"><span style="mso-spacerun:yes">&nbsp;</span>Provided that
we have acted with reasonable professional diligence, in no event shall <span class="SpellE">Keilot</span>, its affiliates or their licensors, service
providers, employees, agents, officers, or directors be liable for damages of
any kind, under any legal theory, arising out of or in connection</span></p>

<p class="MsoNormal" style="margin-top:12.0pt;margin-right:0cm;margin-bottom:
12.0pt;margin-left:0cm"><span lang="EN"><o:p>&nbsp;</o:p></span></p>

<p class="MsoNormal"><span lang="EN"><o:p>&nbsp;</o:p></span></p>

</div>




</body></html>`;

export default enTosHtml;